import { render } from "./AddPlant.vue?vue&type=template&id=ff0384fa&scoped=true"
import script from "./AddPlant.vue?vue&type=script&lang=js"
export * from "./AddPlant.vue?vue&type=script&lang=js"

import "./AddPlant.vue?vue&type=style&index=0&id=ff0384fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0384fa"]])

export default __exports__